/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sequence.reducer';

export const SequenceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sequenceEntity = useAppSelector(state => state.sequence.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sequenceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.sequence.detail.title">Sequence</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.sequence.id">Id</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.id}</dd>
          <dt>
            <span id="order">
              <Translate contentKey="tinyMedicRestApp.sequence.order">Order</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.order}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.sequence.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.instructions}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.sequence.active">Active</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.sequence.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.sequence.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.sequence.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.sequence.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{sequenceEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/sequence" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sequence/${sequenceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SequenceDetail;
